import { SharedDocumalisModule } from '@documalis/shared-documalis.module';
import { NgModule } from '@angular/core';
import { TagBskRoutes } from './tagbsk.routes';
import { ListTagBskComponent } from './list-tagbsk/list-tagbsk.component';
import { FormTagBskComponent } from './_components/form-tagbsk/form-tagbsk.component';
import { AddTagBskComponent } from './add-tagbsk/add-tagbsk.component';
import { EditTagBskComponent } from './edit-tagbsk/edit-tagbsk.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
    imports: [
        TagBskRoutes,
        SharedDocumalisModule,
        TranslateModule,
        FormTagBskComponent,
    ],
    declarations: [
        ListTagBskComponent,
        AddTagBskComponent,
        EditTagBskComponent
    ]
})
export class TagBskModule { }
